export default {
  skills: [],
  tags: [],
  video: null,
  teams: {},
  currentTime: null,
  currentTag: null,
  layout: null,
  fullscreen: false,
  paginationVideos: {
    sortBy: 'created_at',
    descending: true,
    rowsPerPage: 25,
  },
  playing: false,
  tutorial: false,
  tacticalBoard: false,
  canvas: {
    color: {
      hex: '#000000',
    },
    drawingMode: false,
    lineWidth: 1,
    export: '',
    image: '',
    wavy: false,
    dashed: false,
    width: 0,
    height: 0,
    opacity: 0.3,
  },
  activeObject: null,
  canvasObjects: null,
  showTags: true,
  showVideo: true,
  showSkills: true,
  showPlayers: true,
  showTag: true,
  showField: true,
  showTimeline: true,
  enableEdit: false,
  backgroundImage: null,
  downloadWaiting: false,
  saveWaiting: false,
  currentBoard: null,

};



// WEBPACK FOOTER //
// ./src/store/videotags/state.js